$(function() {
  $('.heading__switch').on('click', function(e){
    e.preventDefault();
    var $this = $(this);
    var target = $this.data('target');
    $this.parent().find('.heading__switch').each(function(){
      $(this).removeClass('heading__switch--active');
      $($(this).data('target')).addClass('hidden');
    });
    $this.addClass('heading__switch--active');
    $(target).removeClass('hidden');

    var contW = $this.outerWidth(),
        itemW = $this.find('.carousel__item').outerWidth(),
        visibleItems = contW / itemW,
        navigable = ($this.find('.carousel__item').length > visibleItems && !$this.hasClass('carousel--dotted')) ? true : false,
        grouped = $this.hasClass('carousel--group') ? visibleItems : false,
        contain = grouped ? false : true,
        hasDots = $this.hasClass('carousel--dotted') ? true : false;

    setTimeout(function(){
      $(target).find('.carousel').flickity('destroy').flickity({
      pageDots: false,
      wrapAround: true,
      groupCells: false,
      cellAlign: 'left',
      draggable: true,
      prevNextButtons: true,
      arrowShape: arrowShape,
      // selectedAttraction: 0.013,
      // friction: 0.2,
      contain: contain
    });
    }, 100);

  });
});
